<template>
<div class="nj-panel" v-if="orden_compra">
    <div class="nj-panel-content">
        <div class="nj-subtitle-1">Orden de Compra</div>
        <div class="data">
            <div class="nj-cols c4">
                <Info label="Codigo">{{ orden_compra.ord_code }}</Info>
                <Info label="Centro de Costos">{{ orden_compra.cec_descripcion }}</Info>
                <Info label="Tipo de Orden">{{ orden_compra.ord_tipo_orden_descripcion }}</Info>
                <Info label="Registrado por">{{ orden_compra.ord_usu_logisitica }}</Info>
            </div>
            <div class="nj-cols c4">
                <Info label="Total">{{ orden_compra.ord_monto_cigv | money(orden_compra.mon_simbolo) }}</Info>
                <Info label="Saldo">{{ orden_compra.opg_saldo | money(orden_compra.mon_simbolo) }}</Info>
                <Info label="Saldo (%)">{{ orden_compra.opg_saldo_porcentaje | percentage-sign }}</Info>
            </div>
            <div class="nj-cols c4">
                <Info label="Referencia">{{ orden_compra.ord_referencia }}</Info>
                <Info label="Estado">{{ orden_compra.ore_descripcion }}</Info>
                <Info label="Condición comercial">{{ orden_compra.coc_descripcion }}</Info>
                <Info label="Aprobado por">{{ orden_compra.ord_usu_aprobador }}</Info>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { Info } from "../components"

export default {
    name: "OrdenCompraData",
    components: {
        Info,
    },
    props: {
        orden_compra: null
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {
        
    }
}
</script>

<style scoped></style>